import { handleError } from "./errors/handleError";
import { TimeoutError } from "./errors/TimeoutError";
import { FetchLike, BaseFetchOptions, RequestHandler } from "./options";
import { baseApiRequestHandler } from "./baseApiRequest";

const logRequest = (reqUrl: string): string => {
  process.env.VERBOSE === "1" && console.info(`\x1b[2mreq - ${String(reqUrl)}\x1b[0m`);

  return reqUrl;
};

export const coreFetch = (req: string, init: BaseFetchOptions) => {
  // todo xcc ru only now, remove before launching full prod

  let apiUrl = init.apiUrl;

  if (process.env.NEXT_PUBLIC_APP_ID === "web") {
    if (init.currentLocale === "ru") {
      apiUrl = "https://ru-next.robe.cz";
    }
  }

  const requestHandler = init.requestHandler ?? defaultRequestHandler;
  return requestHandler(apiUrl + req, {
    ...init,
    apiUrl,
  });
};

/** Standard requestHandler which uses global fetch and timeouts after a set time */
const defaultRequestHandler: RequestHandler = (reqUrl, init) => {
  logRequest(reqUrl);

  return baseApiRequestHandler(
    reqUrl,
    fetchWithTimeout(fetch, reqUrl, {
      ...init,
      mode: "cors",
      // This is needed because otherwise server cookie that contains access token won't be passed to server requests
      credentials: "include",
      headers: {
        "content-type": "application/json",
        ...init?.headers,
        ...(init?.authToken && { Authorization: `Bearer ${init.authToken}` }),
      },
    })
  ).then(handleError);
};

/**
 * @throws {TimeoutError}
 */
const fetchWithTimeout = async (fetchFunc: FetchLike, reqUrl: string, options?: BaseFetchOptions) => {
  const timeoutDuration = +(process.env.NEXT_PUBLIC_REQUEST_TIMEOUT ?? options?.timeout ?? 10000);

  const abort = new AbortController();

  // Abort the request after the timeout duration
  const timeoutId = setTimeout(() => abort.abort(), timeoutDuration);

  // If the fetch call has its own abort signal, pass it down to the inner one
  options?.signal?.addEventListener("abort", () => abort.abort());

  try {
    // todo this sometimes throws failed to fetch, after removing page gen add global error boundary
    const res = await fetchFunc(reqUrl, { ...options, signal: abort.signal });

    // Clear the timeout to prevent memory leaks
    clearTimeout(timeoutId);

    return res;
  } catch (e) {
    if (e instanceof Error && e.name === "AbortError") {
      throw new TimeoutError(reqUrl, timeoutDuration);
    }

    throw e;
  }
};
